module.exports = __webpack_public_path__ + "static/media/backWave7.f7fc537b.svg";